module.exports = __webpack_public_path__ + "img/model_01.9873ab07.png";